import { BaseResource } from '../core/base-resource';

export class OrderSmsNotification extends BaseResource {
  orderId: string;
  phone: string;
  provider?: string;
}
